<template>
  <div>
    <div class="bj dis-cent">
      <div class="content">
        <div class="headBox">
          <div class="title">请选择办公区域(至多6个)</div>
          <div class="inpBox"></div>
          <div class="youBox">
            <div class="iconfont icon-close close" @click="gbClick"></div>
          </div>
        </div>
        <div class="cont">
          <div class="contRig">
            <div class="nrCont">
              <div
                class="text dis-cent"
                :class="selectedIds.indexOf(item.id) > -1 ? 'on' : ''"
                v-for="item in areaList"
                :key="item.id"
                @click="contClick(item)"
              >{{ item.name }}</div>
            </div>
            <div class="diCont">
              <div class="name">已选 {{ selectedIds.length }}/6: {{ selectedCn || '暂未选择' }}</div>
              <div class="btn dis-cent" @click="gbClick">确认</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "XuanzeQy",
  data() {
    return {
      areaList: [],
      selectedIds: [],
      selectedNames: [],
    };
  },
  props: ["qyData"],
  created() {
    this.areaList = this.qyData.areaList || [];
    // 以父级传入的 district_cn（已清洗为纯名称）为准，保证与输入框显示一致
    let cn = this.qyData.district_cn;
    if (cn && cn !== "请选择办公区域") {
      this.selectedNames = cn.split(",").filter(Boolean);
      // 根据 name 反查 id，保证 selectedIds 和 selectedNames 同步，且为数字类型
      this.selectedIds = this.selectedNames.map(name => {
        let item = this.areaList.find(a => a.name === name);
        return item ? item.id : null;
      }).filter(id => id !== null);
    }
  },
  methods: {
    contClick(item) {
      let idx = this.selectedIds.indexOf(item.id);
      if (idx > -1) {
        // 取消选中
        this.selectedIds.splice(idx, 1);
        this.selectedNames.splice(idx, 1);
      } else {
        // 新增选中：已达上限 6 个则不处理
        if (this.selectedIds.length >= 6) {
          this.$message.warning("已到达选择上限");
          return;
        }
        this.selectedIds.push(item.id);
        this.selectedNames.push(item.name);
        // 选满 6 个后自动确认关闭
        // if (this.selectedIds.length >= 6) {
        //   this.$nextTick(() => {
        //     this.gbClick();
        //   });
        // }
      }
    },
    gbClick() {
      this.$emit("show", {
        district: this.selectedIds.slice(),
        district_cn: this.selectedNames.join(","),
      });
    },
  },
  mounted() {},
  computed: {
    selectedCn() {
      return this.selectedNames.join(",");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  border-radius: 10px;
  width: 850px;
  height: 600px;
  .headBox {
    height: 70px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    .title {
      font-weight: 600;
      font-size: 18px;
      width: 220px;
    }
    .inpBox {
      width: 250px;
      height: 30px;
    }
    .youBox {
      width: 380px;
      display: flex;
      justify-content: flex-end;
      .close {
        font-weight: 600;
        font-size: 22px;
        cursor: pointer;
      }
    }
  }
  .cont {
    display: flex;
    height: calc(100% - 70px);
    .contRig {
      width: 100%;
      overflow: hidden;
      position: relative;
      .nrCont {
        padding: 20px;
        height: calc(100% - 80px);
        box-sizing: border-box;
        width: 100%;
        overflow: auto;
        .text {
          float: left;
          margin-bottom: 15px;
          padding: 0 13px;
          height: 30px;
          border-radius: 5px;
          background-color: #eef1f5;
          border: 1px solid #eef1f5;
          color: #000;
          margin-right: 15px;
          cursor: pointer;
          box-sizing: border-box;
        }
        .text:hover {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
        .on {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
      }
      .diCont {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          width: 600px;
          word-break: break-all;
          color: #555;
        }
        .btn {
          width: 80px;
          height: 38px;
          border-radius: 38px;
          background-color: #147ee0;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
